/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Import_Error_ParseInputs */



/**
* | output |
* | --- |
* | "Error parsing file. Please check the format." |
*
* @param {Alarms_Import_Error_ParseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_import_error_parse = /** @type {((inputs?: Alarms_Import_Error_ParseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_Error_ParseInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Error parsing file. Please check the format.")
	return /** @type {LocalizedString} */ ("Erreur lors de l'analyse du fichier. Veuillez vérifier le format.")
});